import React, { useCallback } from "react";
import Card from "shared/Card";
import Checkbox from "shared/@forms/Checkbox";
import { Column, Row, Section } from "shared/layout";
import styles from "./index.module.css";

export default function SearchQueryBuilder({ params, onChange }) {
  const { pins, filters } = params;

  const togglePin = useCallback(
    (value) => {
      let newPins;

      if (params.pins.includes(value)) {
        newPins = params.pins.filter((p) => p !== value);
      } else {
        newPins = [...params.pins, value].sort();
      }

      onChange({
        ...params,
        pins: newPins,
      });
    },
    [params, onChange]
  );

  const toggleFilter = useCallback(
    (value) => {
      let newFilters;

      if (params.filters.includes(value)) {
        newFilters = params.filters.filter((p) => p !== value);
      } else {
        newFilters = [...params.filters, value].sort();
      }

      onChange({
        ...params,
        filters: newFilters,
      });
    },
    [params, onChange]
  );

  return (
    <Card className={styles.container}>
      <Row>
        <Column>
          <Section>
            <header>
              <h3>Include Pins</h3>
            </header>

            <Row>
              <Column>
                <div className={styles.checkboxGroup}>
                  <Checkbox
                    id="diamondsCheckbox"
                    checked={pins.includes(4)}
                    onChange={() => togglePin(4)}
                  />
                  <label htmlFor="diamondsCheckbox">Diamonds</label>
                </div>

                <div className={styles.checkboxGroup}>
                  <Checkbox
                    id="platinumsCheckbox"
                    checked={pins.includes(2)}
                    onChange={() => togglePin(2)}
                  />
                  <label htmlFor="platinumsCheckbox">Platinums</label>
                </div>
              </Column>
              <Column>
                <div className={styles.checkboxGroup}>
                  <Checkbox
                    id="emeraldsCheckbox"
                    checked={pins.includes(3)}
                    onChange={() => togglePin(3)}
                  />
                  <label htmlFor="emeraldsCheckbox">Emeralds</label>
                </div>
              </Column>
            </Row>
          </Section>
        </Column>

        <div className={styles.divider} />

        <Column>
          <Section>
            <header>
              <h3>Filters</h3>
            </header>

            <Row>
              <Column>
                <div className={styles.checkboxGroup}>
                  <Checkbox
                    id="activeMembership"
                    checked={filters.includes("active")}
                    onChange={() => toggleFilter("active")}
                  />
                  <label htmlFor="activeMembership">Active Membership</label>
                </div>

                <div className={styles.checkboxGroup}>
                  <Checkbox
                    id="validatedEmail"
                    checked={filters.includes("verified")}
                    onChange={() => toggleFilter("verified")}
                  />

                  <label htmlFor="validatedEmail">Validated Email</label>
                </div>
              </Column>
              <Column>
                <div className={styles.checkboxGroup}>
                  <Checkbox
                    id="onDigitalDelivery"
                    checked={filters.includes("delivery")}
                    onChange={() => toggleFilter("delivery")}
                  />
                  <label htmlFor="onDigitalDelivery">
                    Has Digital Delivery
                  </label>
                </div>

                <div className={styles.checkboxGroup}>
                  <Checkbox
                    value="!basic"
                    id="hideBasic"
                    checked={filters.includes("!basic")}
                    onChange={() => toggleFilter("!basic")}
                  />
                  <label htmlFor="hideBasic">Hide Basic</label>
                </div>
              </Column>
            </Row>
          </Section>
        </Column>
      </Row>
    </Card>
  );
}
